import { render, staticRenderFns } from "./FaceAISettings.vue?vue&type=template&id=3c10d9f8"
import script from "./FaceAISettings.vue?vue&type=script&lang=js"
export * from "./FaceAISettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports